export default "__VITE_ASSET__27fd977d__"